import { Component, Input } from '@angular/core';
import { ProvidersService, FCCONFIG, CommonService } from 'fccore2';
import { FcComponent } from '../fc';
import { CacheService } from 'fccore2';
import { SystemBusiness } from 'fccore2';
import { FcEvent } from '../business/fcevent.event';
import { fcnavbarFindMenusByToken, fcnavbarsetMenushoworhide } from '../business/fcnavbar.business';
/**
 * fc-navbarå·¥å·æ¡å¯¼èª
 * å·¥å·æ¡å¯¼èªç»ä»¶ã
 * é¦é¡µé¡¶é¨å¯¼èªæ å¸å±ä½¿ç¨ã
 * äºä»¶
 * 1.å¼å³äºä»¶ï¼toggle
 * 2.ç»åºäºä»¶ï¼logout
 * 3.åæ¢èåæ°æ®äºä»¶ï¼selectMenu
 * 4.éä¸­ä¸æäºä»¶ï¼selectDropdown
 * 5.å·¥å·æ äºä»¶ï¼selectToolbar
 * 6.ä¿®æ¹ç¨æ·äºä»¶ï¼editUser
 * 7.åæ¢å¸å±äºä»¶ï¼changeLayout
 * 8.åæ¢ä¸»é¢ç®è¤äºä»¶ï¼changeThemes
 */
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'fc-navbar',
    template: `
    <header class="fc-navbar"
    [ngClass]="{'fc-navbar-fixed':fcFixed,'fc-full':fcFull,'fc-navbar-small':fcSize==='small','fc-navbar-default':fcSize==='default','fc-navbar-large':fcSize==='large'}"
    [style.zIndex]="fcZindex" [style.backgroundColor]="fcColor">
    <div class="logo">
        <fc-icon class="logo-icon" fcSize="default"  (click)="_event(fcevent.fcnavbarHideOrShowMenu,$event)" title="åæ¢èå" [fcIcon]="fcLogo"></fc-icon>
        <img class="logo-img"  (click)="_event('goHome',$event)" title="åå°é¦é¡µ" [src]="fcLogoSrc" width="30" height="30" *ngIf="fcLogoSrc!==undefined"/>
        <span class="title">{{fcTitle}}<small>{{menuName}}</small></span>
    </div>
    <div class="fc-navbar-content">
        <ul class="fc-navbar-menu">
            <ng-container *ngFor="let item of simpleMenus">
                <li class="fc-navbar-menu-item" *ngIf="item.HIDDEN==undefined || item.HIDDEN === false" (click)="_event('selectMenu',item)" >
                    <fc-icon fcSize="small" class="fcnavbar-item-icon" *ngIf="undefined!==item.MENUICON&&''!==item.MENUICON&&null!==item.MENUICON" [fcIcon]="item.MENUICON"></fc-icon>
                    {{ item.MENUNAME }}
                </li>
            </ng-container>
            <li class="fc-navbar-menu-item ng-star-inserted" >
                <ng-container *ngIf="moreMenus.length>0">
                    <a class="ant-dropdown-link"  nz-dropdown style="color:hsla(0,0%,100%,.67);" [nzDropdownMenu]="moremenu">
                            <fc-icon fcSize="small" style="margin-right:-2px;font-size:18px"
                            *ngIf="undefined!==moreMenus[0].MENUICON&&''!==moreMenus[0].MENUICON&&null!==moreMenus[0].MENUICON"
                            [fcIcon]="moreMenus[0].MENUICON"></fc-icon>
                            {{moreMenus[0].MENUNAME}}
                            <i nz-icon type="down"></i>
                    </a>
                    <nz-dropdown-menu #moremenu="nzDropdownMenu" [nzTrigger]="'click'" class="develop-navdrop-down">
                        <ul nz-menu>
                            <ng-container *ngFor="let item of moreMenus">
                                <li nz-menu-item *ngIf="item.HIDDEN==undefined || item.HIDDEN === false" (click)="_event('selectDropdown',item)">
                                    <a rel="noopener noreferrer" href="javascript:;">
                                        <fc-icon fcSize="small" *ngIf="undefined!==item.MENUICON&&''!==item.MENUICON&&null!==item.MENUICON" [fcIcon]="item.MENUICON"></fc-icon>
                                        {{item.MENUNAME}}
                                    </a>
                                </li>
                            </ng-container>
                        </ul>
                    </nz-dropdown-menu>
                </ng-container>
            </li>
        </ul>
        <div class="fc-navbar-icon" style="margin-left:0px;">
            <ng-container *ngIf="menus&&menus.length!==0" >
                <a class="ant-dropdown-link" nz-dropdown style="color:hsla(0,0%,100%,.67);"
                [nzDropdownMenu]="menusD">
                            {{selectedMenuName}}
                            <i nz-icon nzType="down"></i>
                </a>
                <nz-dropdown-menu #menusD="nzDropdownMenu" [hidden]="menus.length==1">
                    <ul nz-menu nzSelectable>
                        <ng-container *ngFor="let menu of menus">
                        <li nz-menu-item *ngIf="((menu.HIDDEN!==undefined&&menu.HIDDEN === false)||menu.HIDDEN==undefined)" (click)="_event('selectParentMenudown',menu)">
                            <a rel="noopener noreferrer" href="javascript:;">
                                <fc-icon fcSize="small" class="fcnavbar-item-icon" style="margin-right:-4px;font-size:18px"
                                *ngIf="menu.MENUICON&&''!==menu.MENUICON"
                                [fcIcon]="menu.MENUICON"></fc-icon>
                                {{menu.MENUNAME}}
                            </a>
                        </li>
                        </ng-container>
                    </ul>
                </nz-dropdown-menu>
            </ng-container>
            <ng-container *ngIf="fcOption.fcMenus!==undefined&&fcOption.fcMenus.length!==0" >
                <a class="ant-dropdown-link" nz-dropdown style="color:hsla(0,0%,100%,.67);">
                    æ´å¤...
                    <fc-icon [fcIcon]="'fc-icon-fall'"></fc-icon>
                </a>
                <nz-dropdown-menu nzTrigger="click">
                    <ul nz-menu>
                        <li nz-menu-item *ngFor="let menu of fcOption.fcMenus" (click)="_event('selectDropdown',menu)">
                            <a>{{menu.label}}</a>
                        </li>
                    </ul>
                </nz-dropdown-menu>
            </ng-container>
            <div [hidden]="true" class="fc-navbar-switch-layout" *ngIf="fcSwitchLayout==='Y'">
                <fc-switch [(ngModel)]="layout" (ngModelChange)="_event(events.fcnavbarChangeLayout,$event?'MENU':'TAB')"  fcShowLabel="N" [fcCheckValue]="fcLayout" fcCheckedChildren="MENU"  fcUnCheckedChildren="TAB" fcOption='[{"label":"TAB","value":"TAB"},{"label":"MENU","value":"MENU"}]'>
                </fc-switch>
            </div>
            <nz-dropdown-menu nzTrigger="click" *ngIf="fcSwitchTheme==='Y'" [ngClass]="{'fc-navdropdown-small':fcSize === 'small','fc-navdropdown-default':fcSize === 'default','fc-navdropdown-large':fcSize === 'large'}">
                <a class="ant-dropdown-link" nz-dropdown>
                    <span class="fcdropdowntitle">{{themesOption.title}}</span><i nz-icon type="down"></i>
                </a>
                <ul nz-menu>
                    <li (click)="_event('changeThemes',item)" *ngFor="let item of themesOption?.label" nz-menu-item>
                        <a>{{item}}</a>
                    </li>
                </ul>
            </nz-dropdown-menu>
            <fc-icon fcSize="default" [fcIcon]="'fc-icon-information'" ngClass=" toolbar-control toolbar-control-message" [fcColor]="'#ffffff'" class="informationicon" (click)="_event(events.fcnavbarMessageToggle,$event)"></fc-icon>
            <fc-tooltip *ngFor="let item of fcOption.fcToolbar" fcTitle="{{item.label}}" fcPosition="bottomRight" (click)="_event('selectToolbar',item)">
                <i *ngIf="item.href===undefined||item.href===''" class="{{item.icon}}" fccontent></i>
                <a *ngIf="item.href!==undefined&&item.href!==''" href="{{item.href}}" fccontent>
                    <i class="{{item.icon}}"></i>
                </a>
            </fc-tooltip>
            <fc-avatar  fcToolTip="ä¸ªäººä¿¡æ¯" [fcIcon]="fcUser" class="imghead" (click)="_event('editUser',$event);" fccontent></fc-avatar>
            <span class="name" *ngIf="userInfo!==undefined&&userInfo!==null">{{userInfo?.NAME}}</span>
            <span class="line" *ngIf="fcSwitchCompany==='Y'"></span>
            <nz-dropdown-menu style="margin-right:10px;" nzTrigger="click" *ngIf="fcSwitchTheme==='Y'" [ngClass]="{'fc-navdropdown-small':fcSize === 'small','fc-navdropdown-default':fcSize === 'default','fc-navdropdown-large':fcSize === 'large'}">
                <a class="ant-dropdown-link" nz-dropdown>
                    <span class="fcdropdowntitle">{{themesOption.title}}</span><i nz-icon type="down"></i>
                </a>
                <ul nz-menu>
                    <li (click)="_event('changeThemes',item)" *ngFor="let item of themesOption?.label" nz-menu-item>
                        <a>{{item}}</a>
                    </li>
                </ul>
            </nz-dropdown-menu>
            <span title="ç¹å»åæ¢" style="cursor:pointer;" *ngIf="fcSwitchCompany==='Y'">
                <span class="analyze" [title]="shortName" *ngIf="shortName!==undefined&&shortName!==null" (click)="_event(fcevent.fcnavbarSelectCompany,$event)">{{shortNames}}</span>
                <span class="analyze-date" *ngIf="loginDate!==undefined&&loginDate!==null" (click)="_event(fcevent.fcnavbarSelectDate,$event)">{{loginDate|date:'yyyy-MM-dd'}}</span>
            </span>
            <span class="fc-navbar-exit" (click)="_event(events.fcnavbarLogout,$event)">
                <fc-icon [fcColor]="'#fff'" [fcIcon]="'fc-icon-logout'" fcSize="large" class=" toolbar-control navbar-icon-size exitbutton exitbuttonout"></fc-icon>
            </span>
        </div>
    </div>
</header>
    `,
    styles: [`
    .fc-navbar{
        overflow:hidden;
        white-space:nowrap;
        display: flex;
        justify-content: space-between;
        box-shadow: 0 1px 8px rgba(0,0,0,.3);
    }
    .fc-navbar-fixed{
        position: fixed;
        width: 100%;
        left: 0;
    }
    .fc-full{
        width: 100%;
        height: 100%;
    }
    .logo {
        color:#fff;
        font-size:20px;
        padding-left:12px;
        height: 100%;
        display:flex;
        align-items:center;
        cursor:pointer;
    }
    .logo-icon {
        margin-right:6px;
        color:#ffffff;
    }
    .logo-img {
        margin-right:10px;
        color:#ffffff;
        height: 14px;
    }
    .fc-navbar-content {
        padding-right:8px;
    }
    .fc-navbar-content:after{
        content:'';
        display:block;
        clear:both;
    }
    .fc-navbar .fc-navbar-menu {
        float:left;
        border-bottom:0;
        height:100%;
        line-height: 50px;
    }
    .fc-navbar .fc-navbar-menu:after{
        content:'';
        display:block;
        clear:both;
    }
    .fc-navbar-menu .fc-navbar-menu-item{
        height:100%;
        padding-left:10px;
        padding-right:10px;
        color:hsla(0,0%,100%,.67);
        box-sizing:border-box;
        display: flex;
        align-items: center;
        cursor:pointer;
        float:left;
        font-size:16px;
    }
    .fc-navbar-menu .fc-navbar-menu-item:hover,.fc-navbar-menu .fc-navbar-menu-item-selected{
        color:#ffffff;
    }
    .fc-navbar .fc-navbar-menu-item i{
        margin-right:10px;
    }
    .fc-navbar .fc-navbar-icon{
        height: 100%;
        display:flex;
        align-items:center;
        float:left;
    }
    .clearfix:after{
        content:'';
        display:block;
        clearï¼both
    }
    .navbar-icon-size{
        font-size:20px;
    }
    .toolbar-control {
        font-size:16px;
        color:#000;
        margin-left:13px;
    }
    :host ::ng-deep .toolbar-control .iconfont{
        cursor:pointer;
    }
    .toolbar-control:hover{
        color:#ffffff;
    }
    .settings {
        width:150px;
    }
    :host ::ng-deep .ant-popover .ant-popover-inner-content {
        padding:0;
    }
    .fc-navbar-exit{
        height:46px;
        line-height:46px;
        border-left: 1px solid #187FEE;
    }
    .fc-navbar-exit:after{
        content:'';
        display:block;
        clear:both;
    }
    .exittext{
        margin-left:3px;
        font-size:16px;
        color:#ffffff;
        float:right;
        cursor:pointer;
    }
    .exitbutton{
        float:left;
        margin-left: 8px;
        margin-top: 4px;
    }
    .exitall{
        border-left:1px solid #1873e3;
        height: 46px;
        line-height: 46px;
    }
    .fallmaright{
        margin-right:15px;
        margin-left:10px;
    }
    .analyze{
        font-size:16px;
        color:#ffffff;
        margin-right:5px;
    }
    .analyze-date{
        border-left:1px solid #1873e3;
        padding-left:5px;
        font-size:12px;
        color:#ffffff;
        margin-right:13px;
    }
    .name{
        margin-right:13px;
        color:#ffffff;
        font-size:16px;
    }
    .imghead{
        width:30px;
        height:30px;
        margin-left:10px;
        margin-right:4px;
    }
    :host ::ng-deep .imghead .ant-avatar-icon{
        cursor:pointer;
    }
    ::ng-deep .imghead .ant-avatar{
        width:100%;
        height:100%;
        line-height:27px;
    }
    .title{
        font-size:20px;
    }
    .address{
        margin-right:13px;
        margin-left:13px;
    }
    .fc-navbar-switch-layout{
        width: 50px;
        margin-left: 10px;
    }
    .develop-navdrop-down{
        height:100%;
        margin-left:0px;
        line-height:46px;
    }
    .develop-navdrop-down a{
        font-size:16px;
    }
    .logo i{
        font-size:14px;
    }
    ::ng-deep .address .fcdropdowntitle{
        border-left:1px solid #ffffff;
        padding-left:13px;
    }
    .line{
        width:15px;
        height:16px;
        border-left:1px solid #ffffff;
        display:inline-block;
    }
    :host ::ng-deep .exitbuttonout>i{
        margin-top: 3px;
        display: inline-block;
    }
    :host ::ng-deep .informationicon>i{
        display: inline-block;
        cursor:pointer;
    }
    :host ::ng-deep  .fc-icon-logout:before{
        cursor:pointer;
    }
    .fcnavbar-item-icon{
        margin-right:2px;
    }
    :host ::ng-deep .ant-dropdown-link.ant-dropdown-trigger .fcnavbar-item-icon.ng-star-inserted i{
        font-size:20px;
        margin-right:-3px;
    }
    .informationicon {
        margin-top: 6px;
        display: inline-block;
    }
    :host ::ng-deep .ant-dropdown-link{
        color: #ffffff;
    }
    `]
})
export class FcnavbarComponent extends FcComponent {
    events: any = FcEvent.fcnavbar;
    @Input()
    shortName: string;
    shortNames: string;
    @Input()
    loginDate: string;
    @Input()
    fcFixed: boolean = false;
    @Input()
    fcZindex: number = 100;
    /** é¡¹ç®åå­ */
    @Input()
    fcTitle: string;
    /** å®½é«100% */
    @Input()
    fcFull: boolean = false;
    /** ä¸»é¢é¢è² */
    @Input()
    fcColor: string;
    /** logoå¾çè·¯å¾ */
    @Input()
    fcLogoSrc: string;
    /** logoå¾æ  */
    @Input()
    fcLogo: string = 'fc-icon-bglist';
    /** éç½® */
    @Input()
    fcOption: FCNAVBAROPTIONS;
    /** æé®ç» */
    menus: any[];
    // æé¡¶é¨èå
    parentMenus: any[] = [];
    // äºçº§èå
    simpleMenus: any[] = [];
    // äºçº§èååç§°
    menuName: string = '';
    /** æ´å¤ */
    moreMenus: any[] = [];
    /** è·åç¨æ·å */
    userInfo: any;
    /** ç¨æ·å */
    userName: string;
    /** å¬å¸å */
    userCompany: string;
    /** å¤´å */
    @Input()
    fcUser: string = 'user';
    /** æ¯å¦åè®¸å¸å±åæ¢ */
    @Input()
    fcSwitchLayout: string;
    /** æ¯å¦åè®¸å¸å±åæ¢ */
    @Input()
    fcSwitchCompany: string;
    @Input()
    fcLayout: string;
    layout: boolean;
    selectedMenuName: string;
    /** æ¯å¦åè®¸ä¸»é¢åæ¢ */
    @Input()
    fcSwitchTheme: string;
    /** @Input() */
    /** themesOption: any; */
    /** ç®è¤ä¸æ¥éé¡¹ */
    themesOption: any = {
        title: 'ä¸»é¢',
        label: ['default', 'blue', 'dark']
    };
    interval: any;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-navbar');
        this.fcStatus = 'closed';
        if (this.fcOption === undefined) {
            this.fcOption = { fcMenus: [], fcToolbar: [] };
        }
        /** è·åç¨æ·ä¿¡æ¯ */
        this.userInfo = this.provider.userService.getUserInfo();
        /** åå§ålogoå¾æ  */
        if (this.fcLogo === undefined) {
            this.fcLogo = 'fc-icon-bglist';
        }
        /** æ¯å¦åè®¸åæ¢å¸å± */
        if (this.fcSwitchLayout === undefined) {
            this.fcSwitchLayout = 'N';
        }
        /** æ¯å¦åè®¸åæ¢ä¸»é¢ */
        if (this.fcSwitchTheme === undefined) {
            this.fcSwitchTheme = 'N';
        }
        /** æ¯å¦åè®¸åæ¢åä½ */
        if (this.fcSwitchCompany === undefined) {
            this.fcSwitchCompany = 'Y';
        }
        // éæ°å è½½èå
        this.pushDestroy(CommonService.subscribe(this.events.fcnavbarLoadingMenu, (param) => {
            this.pushDestroy(fcnavbarFindMenusByToken(FCCONFIG.pid, param.param.SCOMPANY_CODE).subscribe(result => {
                if (result.CODE === '0' && result.DATA && result.DATA.length > 0) {
                    this.menus = result.DATA;
                    SystemBusiness.menus = this.menus;
                    const grandMenu = CacheService.get('SELECTEDGRANDPARENTMENU');
                    let selectedGrandMenu: any;
                    if (grandMenu) {
                        const isinList = this.menus.filter(m => m.ID === grandMenu.ID);
                        if (isinList.length > 0) {
                            selectedGrandMenu = isinList[0];
                        }
                    }
                    if (selectedGrandMenu === undefined) {
                        selectedGrandMenu = this.menus[0];
                    }
                    if (this.menus && this.menus.length > 0) {
                        if (selectedGrandMenu && selectedGrandMenu.P_CHILDMENUS.length > 6) {
                            this.simpleMenus = selectedGrandMenu.P_CHILDMENUS.slice(0, 5);
                            this.moreMenus = selectedGrandMenu.P_CHILDMENUS.slice(5);
                        } else {
                            this.simpleMenus = selectedGrandMenu.P_CHILDMENUS;
                        }
                        if (selectedGrandMenu === undefined) {
                            selectedGrandMenu = this.menus[0];
                        }
                        // ç¥ç¶çº§èååç§°
                        this.selectedMenuName = selectedGrandMenu.MENUNAME;
                        // åå¾å½åéæ©çç¶çº§
                        const seletedParentMenu = CacheService.get('SELECTEDPARENTMENU');
                        let menu: any;
                        if (seletedParentMenu) {
                            const isinList = selectedGrandMenu.P_CHILDMENUS.filter(m => m.ID === seletedParentMenu.ID);
                            if (isinList.length > 0) {
                                menu = isinList[0];
                            }
                        }
                        if (menu === undefined) {
                            menu = selectedGrandMenu.P_CHILDMENUS[0];
                        }
                        this._event('selectMenu', menu);
                    }
                } else {
                    this.menus = [];
                    this.selectedMenuName = '';
                    SystemBusiness.menus = [];
                    this.simpleMenus = [];
                    this.moreMenus = [];
                }
                // å è½½å®ååçäºä»¶
                CommonService.event(this.events.fcnavbarEndLoadMenu, this.menus);
            }));
        }));
        // çå¬éèå è½½çèå
        this.pushDestroy(CommonService.subscribe(FcEvent.fcnavbar.fcnavbarInvisible, (param) => {
            fcnavbarsetMenushoworhide(this.menus, param.param, true);
            this.menus = Object.assign([], this.menus);
            let exist = false;
            for (const m of this.menus) {
                if (exist) {
                    this.selectedMenuName = m.MENUNAME;
                    this.simpleMenus = m.P_CHILDMENUS;
                    this._event('selectMenu', m);
                    break;
                }
                if (m.MENUNAME === this.selectedMenuName && param.param.indexOf(m.MENUID) !== -1) {
                    if (m.HIDDEN !== undefined && m.HIDDEN === true ) {
                        exist = true;
                        this.simpleMenus = [];
                        continue;
                    } else {
                        break;
                    }
                }
            }
        }));
        // çå¬æ¾ç¤ºå è½½çèå
        this.pushDestroy(CommonService.subscribe(FcEvent.fcnavbar.fcnavbarVisible, (param) => {
            fcnavbarsetMenushoworhide(this.menus, param.param, false);
            this.menus = Object.assign([], this.menus);
        }));
    }
    ngOnInit() {
        CommonService.event(this.events.fcnavbarLoadingMenu, {
            SCOMPANY_CODE: this.userInfo.SYSLOGINHIS[0].SCOMPANY_CODE
        });
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcTheme === undefined) {
            this.fcTheme = 'dark';
        }
        if (this.fcLayout && this.fcLayout === 'MENU') {
            this.layout = true;
        } else {
            this.layout = false;
        }
        if (this.fcStatus === undefined || this.fcStatus === '') {
            this.fcStatus = 'closed';
        }
        if (this.shortName) {
            if (this.shortName.length > 14) {
                this.shortNames = this.shortName.substr(0, 14) + '...';
            } else {
                this.shortNames = this.shortName;
            }
        }
    }
   /**
    * åå°é¦é¡µ
    */
    _event(eventName, param) {
        switch (eventName) {
            case 'goHome':
                SystemBusiness.navigate(['/home']);
                break;
            case 'selectCompany':
                // /**æ´æ°å°æ¬å°ç¼å­åçåä½ä¿¡æ¯ */
                super.event(eventName, CacheService.getS('LASTLOGINCOMPANY'));
                break;
            case this.events.fcnavbarMessageToggle: // å¼¹åºä¾§è¾¹æ æ¶æ¯
                if (this.fcStatus === 'closed') {
                    this.fcStatus = 'opened';
                } else if (this.fcStatus === 'opened') {
                    this.fcStatus = 'closed';
                }
                super.event(this.events.fcnavbarMessageToggle, this.fcStatus);
                break;
            case 'selectParentMenudown':
                this.selectedMenuName = param.MENUNAME;
                this.moreMenus = [];
                if (param && param.P_CHILDMENUS.length > 6) {
                    this.simpleMenus = param.P_CHILDMENUS.slice(0, 5);
                    this.moreMenus = param.P_CHILDMENUS.slice(5);
                } else {
                    this.simpleMenus = param.P_CHILDMENUS;
                }
                CacheService.set('SELECTEDGRANDPARENTMENU', param);
                break;
            case 'selectMenu':
            case 'selectDropdown':
                this.menuName = '-' + param.MENUNAME;
                CacheService.set('SELECTEDPARENTMENU', param);
                super.event(eventName, param);
                break;
            default:
                super.event(eventName, param);

        }
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        clearInterval(this.interval);
    }


}

export interface FCNAVBAROPTIONS {
    /** å¸¦å¾æ çå¯¼èª */
    fcMenuslabel?: string;
    fcMenus?: FCNAVBARMENU[];
    fcToolbar?: FCNAVBARTOOLTIP[];
}
export interface FCNAVBARMENU {
    code: string;
    icon?: string;
    label: string;
    router?: string;
}
export interface FCNAVBARTOOLTIP {
    code: string;
    icon?: string;
    label: string;
    router?: string;
    href?: string;
    action?: string; /** æ¹æ³ */
    isPopover: boolean;
    popChild: FCNAVBARMENU[];
}
